"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalNames = exports.ProcessingStatus = exports.ApiFields = exports.GATES = exports.GOOGLE_DRIVE_GATE = exports.MethodTypes = exports.MessageTypes = exports.RequestStatus = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var RequestStatus = (0, _keyMirror.default)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
exports.RequestStatus = RequestStatus;
var MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
exports.MessageTypes = MessageTypes;
var MethodTypes = {
  CREATE: 'POST',
  DELETE: 'DELETE',
  UPDATE: 'PATCH'
};
exports.MethodTypes = MethodTypes;
var GOOGLE_DRIVE_GATE = 'cos_blog_googledrive';
exports.GOOGLE_DRIVE_GATE = GOOGLE_DRIVE_GATE;
var GATES = ['composer_lib_toolbar_beta', 'cos_blog_beta', 'cos_blog_beta_optedout', 'cos_blog_collect_beta', 'cos_blog_compose_clip_gallery', GOOGLE_DRIVE_GATE, 'cms-control-center-exclusions', 'cms-control-center'];
exports.GATES = GATES;
var ApiFields = ['processingStatus'];
exports.ApiFields = ApiFields;
var ProcessingStatus = {
  COMPOSING: 'composing',
  FORMATTING: 'formatting'
};
exports.ProcessingStatus = ProcessingStatus;
var ModalNames = {
  COMPOSE_EDIT_INTERSTITIAL: 'composeEditInterstitionalModal',
  ONBOARDING: 'onboardingModal'
};
exports.ModalNames = ModalNames;